module.exports = __webpack_public_path__ + "img/reference.1c88c3b9.png";